export interface User
{
};

export interface Token
{
    accessToken: string;
    expires: string;
};

export const Storage = {
    user:
    {
        set: (user: User) => localStorage.setItem('portal-eurofarma:user',  JSON.stringify(user)),
        get: () => { return JSON.parse(localStorage.getItem('portal-eurofarma:user') as string) as User || null; },
    },
    token:
    {
        set: (token: Token) => localStorage.setItem('portal-eurofarma:token',  JSON.stringify(token)),
        get: () => { return JSON.parse(localStorage.getItem('portal-eurofarma:token') as string) as Token || null; },
    }
};

export default Storage;